import { useState, useEffect } from "react";

const useIsSmallDevice = () => {
  const [isSmallDevice, setIsSmallDevice] = useState(false);
  const [isMinSmallDevice, setIsMinSmallDevice] = useState(false);
  const [orientation, setOrientation] = useState(1);

  /**
   * A React `useEffect` hook that checks if the window's width is smaller than 768px
   * and updates the `isSmallDevice` state accordingly. The check is performed on
   * component mount and whenever the window is resized.
   */
  useEffect(() => {
    const checkDeviceSize = () => {
      setIsSmallDevice(window.innerWidth < 1130);
      setIsMinSmallDevice(window.innerWidth < 806);
      if (window.innerWidth > window.innerHeight) {
        setOrientation(1);
      } else {
        setOrientation(0);
      }
    };
    checkDeviceSize();
    window.addEventListener("resize", checkDeviceSize);
    return () => {
      window.removeEventListener("resize", checkDeviceSize);
    };
  }, []);

  return {
    isSmallDevice,
    isMinSmallDevice,
    orientation,
  };
};

export default useIsSmallDevice;
